import React, { useEffect } from "react";
import "./App.scss";
import "./styles/css/common.scss";
import "./styles/css/mobile.scss";
import "./styles/css/vars.scss";
import "../src/page/InspectionChecklist/inspection.scss";
import Router from "@src/routers/router";
import { Layout } from "antd";
import Loading from "@src/component/Popup/loading";
import Confirm from "@src/component/Popup/confirm";
import { useDispatch, useSelector } from "react-redux";
import { changeStatusNetWork, getUserInfo } from "@src/redux/auth";
import { useHistory } from "react-router-dom";
import moment from "moment-timezone";
import { useParams ,useLocation} from "react-router-dom";
import ScrollToTop from "./component/utils/ScrollToTop";
const { Content } = Layout;
// reset item page to select menu when reload page or destroy app
window.onbeforeunload = function () {
  localStorage.removeItem("page");
};

function App() {
  moment.updateLocale("ja", {
    week: {
      dow: 0, //set sunday as the first day of week
    },
  });
 
  const { currentUser, currentRouter, changeRoute } = useSelector(
    (state) => state.checklist
  );
  const location = useLocation()
  // const { inMultipleSites } = useSelector((state) => state.auth);
  const history = useHistory();
  const dispatch = useDispatch();
  const onOffline = () => {
    dispatch(changeStatusNetWork(false));
  };
  const onOnline = () => {
    dispatch(changeStatusNetWork(true));
  };
  useEffect(() => {
    dispatch(getUserInfo(currentUser));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (changeRoute !== null) {
      let route = history.location.pathname;
      if (changeRoute) {
        history.push("/");
      } else {
        // in case open new tab with new route below while using input checklist
        if (
          !(route.includes("/ViewReport") || route.includes("/history-detail") || route.includes("/ViewMachine") || route.includes("/VideoManagement/View/"))
        ) {
          const currentQuery = location.search; 
          if (currentRouter.includes("/list")) {
            history.push(currentRouter + currentQuery);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeRoute]);
  let vh = window.innerHeight * 0.01;
  // set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  // We listen to the resize event
  window.addEventListener("resize", () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });
  useEffect(() => {
    window.addEventListener("offline", onOffline);
    window.addEventListener("online", onOnline);
    return () => {
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("online", onOnline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  const path = location.pathname;
  const keySearchCheckList = sessionStorage.getItem("searchKey")
  const keySearchCheckListStatus = sessionStorage.getItem("searchKeyStatus")
  if(!path.startsWith("/checklist") && !path.startsWith("/list")){
  if(keySearchCheckList){
    sessionStorage.removeItem("searchKey")
  }
  if(keySearchCheckListStatus){
    sessionStorage.removeItem("searchKeyStatus")
  }
  }
  },[location])

  return (
    <Layout className="layout" id="layout">
      <ScrollToTop />
      <Content>
        <Router />
      </Content>
      <Loading />
      <Confirm />
    </Layout>
  );
}
export default App;
